<app-pdf [url]="url" [page]="page" (pageChange)="pageChange($event)" *ngIf="url"></app-pdf>